var hashtag_default = {
  "fontElementMap": "GkWsc",
  "hashtag": "PoOw6"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
